'use client';
import { ReactNode } from 'react';
import cn from 'classnames';
import { Formik, FormikHelpers, FormikValues, FormikProps } from 'formik';

export interface BaseFormProps<FormValues extends FormikValues> {
  className?: string;
  initialValues: FormValues;
  onSubmit: (values: FormValues, actions: FormikHelpers<FormValues>) => void;
  onSubmitSuccess?: (values: FormValues, response?: unknown) => void;
  onSubmitFailure?: (values: FormValues, response?: unknown) => void;
  children: ReactNode | ((formikProps: FormikProps<FormValues>) => ReactNode);
  validate?: (value: FormValues) => any;
  validateOnBlur?: boolean;
  validateOnChange?: boolean;
}

function Form<FormValues extends FormikValues>(
  props: BaseFormProps<FormValues>
) {
  const {
    className = '',
    initialValues,
    onSubmit,
    children,
    validate,
    validateOnBlur = false,
    validateOnChange = false
  } = props;
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={validate}
      validateOnBlur={validateOnBlur}
      validateOnChange={validateOnChange}
    >
      {(formikProps: FormikProps<FormValues>) => (
        <form
          className={cn('Form', className)}
          onSubmit={formikProps.handleSubmit}
        >
          {typeof children === 'function' ? children(formikProps) : children}
        </form>
      )}
    </Formik>
  );
}

export default Form;
